import {
    booleanAttribute,
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output
} from '@angular/core';
import { CardComponent } from '../../card/card.component';
import { Icons } from '../../icon/constants/icons.constants';
import { IconComponent } from '../../icon/icon.component';
import {
    NotificationType,
    NotificationTypeUnion
} from '../models/notification-type.model';

@Component({
    selector: 'nw-notification-card',
    templateUrl: './notification-card.component.html',
    styleUrls: ['./notification-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CardComponent, IconComponent]
})
export class NotificationCardComponent {
    @Input() type: NotificationType | NotificationTypeUnion = 'information';
    @Input({ transform: booleanAttribute }) fill: boolean = true;
    @Input() icon?: Icons.Type;
    @Input({ transform: booleanAttribute }) loading: boolean = false;

    @Output() raiseEvent: EventEmitter<Event> = new EventEmitter<Event>();

    public NotificationType: typeof NotificationType = NotificationType;
}
